import $ from 'jquery';
import api from "../apiService";
import {initializeSelect2} from '../initialize-select2';
import {clearFields, createDebouncedMemoRequest, disableSaveButton, populateFields, propSpinner} from '../utils';

let otherPlateOldValue = $('[name=other_plate]').val();
const debounceSearch = createDebouncedMemoRequest(api.getData, 300);

export function searchCarAnia(fieldName) {
    const fieldValue = $(`[name="${fieldName}"]`).val();
    const eventDate = $(`[name="event_date"]`).val();

    if (!fieldValue || fieldValue.length <= 5) {
        clearOtherCompanyFields();
        return;
    }

    const cacheKey = `${fieldName}-${fieldValue}-${eventDate}`;

    if (otherPlateOldValue === fieldValue) return;
    otherPlateOldValue = fieldValue;

    propSpinner(['other_company', 'other_insured_fiscal_code', 'other_company_policy', 'other_insured_name', 'other_insured_last_name', 'other_insured'], true);
    disableSaveButton(true);

    debounceSearch(cacheKey, `/api/app/backpack/search-car-ania`, {
        params: {
            [fieldName]: fieldValue,
            event_date: eventDate,
        },
    }).then((data) => {
        if (data) {
            populateOtherCompanyFields(data);
        }
    }).finally(() => {
        propSpinner(['other_company', 'other_insured_fiscal_code', 'other_company_policy', 'other_insured_name', 'other_insured_last_name', 'other_insured'], false);
        disableSaveButton(false);
    });
}

export function populateOtherCompanyFields(data) {
    populateFields(data);
}

export function clearOtherCompanyFields() {
    clearFields(['other_company', 'other_insured_fiscal_code', 'other_company_policy', 'other_insured_name', 'other_insured_last_name', 'other_insured', 'other_ania']);
    initializeSelect2($('select[name="other_company_id"]'), '920');
    initializeSelect2($('select[name="other_veichle_type"]'), null);
    initializeSelect2($('select[name="other_plate_country"]'), 'ITALIA');
}


